<template>
  <div
    :class="`text-${color}`"
    class="smart__loader relative rounded" />
</template>

<script>
export default {
  name: 'SmartLoader',
  props: {
    color: {
      type: String,
      default: 'black'
    }
  }
};
</script>

<style lang="scss">
$size: 1.5rem;

.smart__loader {
  width: $size;
  height: $size;
  border: $border-width-default*3 solid currentColor;
  animation: rotateLoader 2s $transition-easing-default infinite;
  &::after {
    content: '';
    display: block;
    height: 0;
    position: absolute;
    bottom: 0;
    width: 100%;
    background: currentColor;
    animation: fillLoader 1s $transition-easing-default infinite alternate;
  }
}

@keyframes rotateLoader {
  0% {
    transform: rotateZ(0deg);
  }
  50% {
    transform: rotateZ(140deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes fillLoader {
  0% {
    height: 0;
  }
  100% {
    height: 100%;
  }
}

</style>
